
import { useState, useEffect } from "react";
import { db } from "../../firebaseClient";
import { ApprovalFlow } from "../types/approval";

export function useApprovalFlow(module: string, targetId: string) {
  const [flow, setFlow] = useState<ApprovalFlow | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!targetId || !module) {
        setFlow(null);
        return;
    }

    setLoading(true);
    const flowId = `${module}_${targetId}`;
    const unsub = db.collection("approvalFlows").doc(flowId).onSnapshot((docSnap) => {
      if (docSnap.exists) {
        setFlow(docSnap.data() as ApprovalFlow);
      } else {
        setFlow(null);
      }
      setLoading(false);
    }, (err) => {
        console.error("Approval Flow Listener Error", err);
        setLoading(false);
    });

    return () => unsub();
  }, [module, targetId]);

  return { flow, loading };
}
